"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _alloyReactDropdown = require("@adsk/alloy-react-dropdown");
var _react = _interopRequireWildcard(require("react"));
var _DropdownUtils = require("../../utils/components/DropdownUtils");
var _ProjectMemberMultiSelectValueTag = require("./ProjectMemberMultiSelectValueTag");
var _useTranslations = require("../../utils/i18n/useTranslations");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const ProjectMemberMultiSelectNewDropdown = _ref => {
  let {
    members,
    selectedOptions,
    onChange,
    isMemberInvalidFn = () => false
  } = _ref;
  // if the options are not memoized with an empty dependency array
  //  the new alloy dropdown cant handle item deselection in the menu
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const options = (0, _react.useMemo)(() => members, []);
  const groupedItems = (0, _react.useMemo)(() => {
    // TODO: remove when component migration is finalized
    options.forEach(group => group.items = group.options);
    return options;
  }, [options]);
  const {
    T
  } = (0, _useTranslations.useTranslations)();
  const optionMap = (0, _react.useMemo)(() => groupedItems.reduce((map, group) => {
    group.items.forEach(member => map.set(member.value, member));
    return map;
  }, new Map()),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [groupedItems]);
  const getSelectedItems = () => {
    if (!Array.isArray(selectedOptions) || selectedOptions.length < 1) {
      return [];
    }
    // new dropdown requires referential equality for the selected item
    const selectedItems = selectedOptions.reduce((selectedMembers, member) => {
      const selection = optionMap.get(member.value);
      if (selection) {
        selectedMembers.push(selection);
      }
      return selectedMembers;
    }, new Array());
    return selectedItems;
  };
  const selected = getSelectedItems();
  const semanticIdentifier = "project-member-multi-select-dropdown";
  const {
    controlProps,
    menuProps
  } = (0, _alloyReactDropdown.useMultiAutocomplete)({
    // TODO: make items property required, remove options property when migration is finalized
    // @ts-expect-error
    groupedItems,
    selectedItems: selected,
    onSelectedItemsChange: _ref2 => {
      let {
        selectedItems
      } = _ref2;
      return onChange(selectedItems || []);
    },
    id: semanticIdentifier
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_alloyReactDropdown.MultiAutocompleteTokenControl, _extends({}, controlProps, {
    placeholder: T.translate("projectMemberPlaceholder"),
    style: {
      maxHeight: 340
    },
    renderItems: () => /*#__PURE__*/_react.default.createElement("div", {
      style: {
        display: "flex",
        flexWrap: "wrap",
        overflowX: "hidden"
      }
    }, selected === null || selected === void 0 ? void 0 : selected.map((selectedItem, i) => /*#__PURE__*/_react.default.createElement(_ProjectMemberMultiSelectValueTag.ProjectMemberMultiSelectValueTag, _extends({}, selectedItem, {
      invalid: isMemberInvalidFn(selectedItem),
      onRemove: value => onChange(selected.filter(option => option.value !== value)),
      key: i
    })))),
    "data-testid": "".concat(semanticIdentifier, "-control")
  })), /*#__PURE__*/_react.default.createElement(_alloyReactDropdown.AutocompleteMenu, _extends({}, menuProps, {
    renderFooter: () => (0, _DropdownUtils.DropdownFooter)({
      isClearable: true,
      handleChange: () => {
        // work around alloy bug where selectedItem is not updated when clearing
        menuProps.selectItem(null);
        controlProps.selectItem(null);
        onChange([]);
      },
      shouldDisplay: Array.isArray(selected) && selected.length > 0
    }),
    "data-testid": "".concat(semanticIdentifier, "-menu")
  }), menuProps.menuItems.map((itemOrGroupHeader, i) => (0, _alloyReactDropdown.isGroupHeader)(itemOrGroupHeader) ? /*#__PURE__*/_react.default.createElement(_alloyReactDropdown.MenuGroupHeader, {
    key: i,
    "data-testid": "".concat(semanticIdentifier, "-header-").concat(i)
  }, itemOrGroupHeader.label) : /*#__PURE__*/_react.default.createElement(_alloyReactDropdown.MenuItem, _extends({
    key: i
  }, menuProps.getItemProps({
    item: itemOrGroupHeader
  })))), menuProps.menuItems.length === 0 && controlProps.getInputProps() && /*#__PURE__*/_react.default.createElement(_alloyReactDropdown.NoAutocompleteResults, {
    style: {}
  })));
};
var _default = exports.default = ProjectMemberMultiSelectNewDropdown;
//# sourceMappingURL=ProjectMemberMultiSelectNewDropdown.js.map